/**
 * Shared utilities for activity status (licenses and credentials)
 * Used by license-activity-modal and credential-activity-modal
 */

import { Warning, CheckCircle } from '@mui/icons-material'
import type { ReactElement } from 'react'

/**
 * Get color for activity status based on action type
 */
export function getActivityStatusColor(
  actionType: string,
): 'error' | 'warning' | 'success' | 'default' {
  switch (actionType) {
    case 'expired':
      return 'error'
    case 'expiring-soon':
      return 'warning'
    case 'added':
      return 'success'
    default:
      return 'default'
  }
}

/**
 * Get icon for activity status based on action type
 */
export function getActivityStatusIcon(actionType: string): ReactElement {
  switch (actionType) {
    case 'expired':
      return <Warning />
    case 'expiring-soon':
      return <Warning />
    case 'added':
      return <CheckCircle />
    default:
      return <CheckCircle />
  }
}

/**
 * Get label for activity status based on action type
 */
export function getActivityStatusLabel(
  actionType: string,
  daysToExpiration?: number,
  activityType: 'license' | 'credential' = 'license',
): string {
  let typeLabel = activityType === 'license' ? 'License' : 'Credential'

  switch (actionType) {
    case 'expired':
      return `${typeLabel} Expired`
    case 'expiring-soon':
      return `Expiring in ${daysToExpiration} day${daysToExpiration === 1 ? '' : 's'}`
    case 'added':
      return `${typeLabel} Added`
    default:
      return actionType
  }
}
